// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"ea4638fc982d1aa5ce80","936":"49872b4c543958efbfbf"}[chunkId] + ".js";
};